const pushNotificationSystemSubTypes = {
    // EC
    EXP_COACH_FIRST_INFERENCE: 'EXP_COACH_FIRST_INFERENCE',
    EXP_COACH_PUFF_TIME_FAST: 'EXP_COACH_PUFF_TIME_FAST',
    EXP_COACH_PUFF_TIME_OPTIMAL: 'EXP_COACH_PUFF_TIME_OPTIMAL',
    EXP_COACH_STICK_REUSED_DETECTED: 'EXP_COACH_STICK_REUSED_DETECTED',
    EXP_COACH_STICK_REPLACEMENT_GOOD: 'EXP_COACH_STICK_REPLACEMENT_GOOD',
    EXP_COACH_PAUSE_MODE_CORRECT: 'EXP_COACH_PAUSE_MODE_CORRECT',
    EXP_COACH_PAUSE_MODE_INTERRUPTED: 'EXP_COACH_PAUSE_MODE_INTERRUPTED',
    EXP_COACH_SHORT_SESSION_DETECTED: 'EXP_COACH_SHORT_SESSION_DETECTED',
    EXP_COACH_SHORT_SESSION_RESOLVED: 'EXP_COACH_SHORT_SESSION_RESOLVED',
    EXP_COACH_FREQUENT_LIMITATION_DETECTED: 'EXP_COACH_FREQUENT_LIMITATION_DETECTED',
    EXP_COACH_FREQUENT_LIMITATION_RESOLVED: 'EXP_COACH_FREQUENT_LIMITATION_RESOLVED',
    EXP_COACH_DEVICE_OVERHEATING_DETECTED: 'EXP_COACH_DEVICE_OVERHEATING_DETECTED',
    EXP_COACH_DEVICE_OVERHEATING_RESOLVED: 'EXP_COACH_DEVICE_OVERHEATING_RESOLVED',
    EXP_COACH_SCORE_NOT_OPTIMAL: 'EXP_COACH_SCORE_NOT_OPTIMAL',
    EXP_COACH_SCORE_IMPROVED: 'EXP_COACH_SCORE_IMPROVED',
    EXP_COACH_MIXED_CONDITIONS: 'EXP_COACH_MIXED_CONDITIONS',
    EXP_COACH_MULTIPLE_POSITIVE: 'EXP_COACH_MULTIPLE_POSITIVE',
    EXP_COACH_MULTIPLE_NEGATIVE: 'EXP_COACH_MULTIPLE_NEGATIVE',
    // Other
    BATTERY_LEVEL: 'BATTERY_LEVEL',
    ADVANCED_DIAGNOSTICS: 'ADVANCED_DIAGNOSTICS',
    BENEFITS_OF_CONNECTING_DAY_6: 'BENEFITS_OF_CONNECTING_DAY_6',
    BENEFITS_OF_CONNECTING_DAY_11: 'BENEFITS_OF_CONNECTING_DAY_11',
    BENEFITS_OF_CONNECTING_DAY_16: 'BENEFITS_OF_CONNECTING_DAY_16',
    BENEFITS_OF_CONNECTING_DAY_21: 'BENEFITS_OF_CONNECTING_DAY_21',
    LOYALTY_NO_BADGES_ACHIEVED: 'LOYALTY_NO_BADGES_ACHIEVED',
    LOYALTY_LAST_BADGE_ACHIEVED_TIMEOUT: 'LOYALTY_LAST_BADGE_ACHIEVED_TIMEOUT',
    LOYALTY_REWARDS_WAITING: 'LOYALTY_REWARDS_WAITING',
    CONVERSION_BADGE_NOT_COMPLETED_NEXT_AVAILABLE: 'CONVERSION_BADGE_NOT_COMPLETED_NEXT_AVAILABLE',
    CONVERSION_NEW_BADGE_AVAILABLE: 'CONVERSION_NEW_BADGE_AVAILABLE',
    CONVERSION_MILESTONE_NOT_FINISHED: 'CONVERSION_MILESTONE_NOT_FINISHED',
    CONVERSION_MILESTONE_NOT_COMPLETED_NEXT_AVAILABLE: 'CONVERSION_MILESTONE_NOT_COMPLETED_NEXT_AVAILABLE',
    CONVERSION_BADGE_INACTIVITY_DETECTED: 'CONVERSION_BADGE_INACTIVITY_DETECTED',
    RETAIL_VISIT_REMINDER: 'RETAIL_VISIT_REMINDER',
    RETAIL_USER_VISIT: 'RETAIL_USER_VISIT',
};

export default pushNotificationSystemSubTypes;
